// extracted by mini-css-extract-plugin
export var active = "growthRateSelector-module--active--ygUu3";
export var container = "growthRateSelector-module--container--96ijX";
export var label = "growthRateSelector-module--label--JBLzS";
export var rate = "growthRateSelector-module--rate--X6yKK";